import { forwardRef, type Ref, type SVGProps } from 'react';
import { SvgIcon } from '../../components/icon/icon';

interface SVGRProps {
  title?: string;
  titleId?: string;
}
const Calendar = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    ref={ref}
    aria-labelledby={titleId}
    {...props}>
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M3.2 7.65h17.6M7.6 2.15v1.1m8.8-1.1v1.1m-11 17.6h13.2a2.2 2.2 0 0 0 2.2-2.2V5.45a2.2 2.2 0 0 0-2.2-2.2H5.4a2.2 2.2 0 0 0-2.2 2.2v13.2a2.2 2.2 0 0 0 2.2 2.2m2.64-9.13a.44.44 0 1 1-.88 0 .44.44 0 0 1 .88 0m0 4.4a.44.44 0 1 1-.88 0 .44.44 0 0 1 .88 0m4.4-4.4a.44.44 0 1 1-.88 0 .44.44 0 0 1 .88 0m0 4.4a.44.44 0 1 1-.88 0 .44.44 0 0 1 .88 0m4.4-4.4a.44.44 0 1 1-.88 0 .44.44 0 0 1 .88 0m0 4.4a.44.44 0 1 1-.88 0 .44.44 0 0 1 .88 0"
      vectorEffect="non-scaling-stroke"
    />
  </svg>
);
const ForwardRef = forwardRef(Calendar) as SvgIcon;
export { ForwardRef as ReactComponent };
